import * as React from 'react';
import { ArticleHeading3, ArticleParagraph1 } from '@cian/ui-kit';
import { IDiscountNewBuildings } from '../../../types/developer/discounts';
import { Link } from '../../Link';
import * as styles from './Content.css';

interface IContentProps {
  description: string | null;
  newBuildings: IDiscountNewBuildings[];
}

export function Content({ description, newBuildings }: IContentProps) {
  return (
    <>
      {description && <ArticleParagraph1 whiteSpace="pre-line">{description}</ArticleParagraph1>}

      {newBuildings && (
        <div className={styles['promo']}>
          <div className={styles['promo-title']}>
            <ArticleHeading3>Акция проходит в ЖК:</ArticleHeading3>
          </div>
          {newBuildings.map((newBuilding, index) => (
            <Link
              key={newBuilding.id}
              text={newBuildings.length - 1 === index ? newBuilding.name : `${newBuilding.name}, `}
              url={newBuilding.url}
              size="M"
            />
          ))}
        </div>
      )}
    </>
  );
}
